<template>
  <div class="customer-list page page-with-table p-2">
    <page-header class="mb-2" :title="$t('Customers')">
      <template v-slot:buttons>
        <add-new-button v-permission="'change_customer'" @click="showModal">
          <font-awesome-icon icon="plus-circle" class="icon"/>
          {{ $t('New Customer') }}
        </add-new-button>
      </template>
    </page-header>
    <div class="card content-wrapper p-2">
      <CustomerTable :exclude-search-fields="['category_uuids', 'activityDateRange', 'interest_category_uuids']"
                     :exclude-columns="['activity', 'interest_categories']" enable-frontend-export/>
    </div>
  </div>
</template>

<script>
  import AddNewButton from "../../core/components/common/AddNewButton";
  import {createNamespacedHelpers} from "vuex";
  import CustomerTable from "./CustomerTable";
  import PageHeader from "../../core/components/page-header/PageHeader";

  const {mapActions} = createNamespacedHelpers('customer');
  export default {
    name: "Customer",
    components: {PageHeader, CustomerTable, AddNewButton},
    methods: {
      ...mapActions(['showModal', 'updateTableSource']),
    },
    async beforeMount() {
      await this.updateTableSource({source: 'customer'});
    }
  }
</script>

<style lang="scss" scoped>
  @import "./scss/variables";

  .customer-list {
    @include list-view-wrapper;
  }
</style>

